module.exports = __webpack_public_path__ + "static/media/bp24.b55a4a81.jpg";